export enum SoProcessTypesEnum { 
    MTS = 'MTS',
    MTO = 'MTO',
    SAMPLES = 'Samples',
}